import { SPECIAL_KEYS } from 'components/Keyboard/utils/constants';

export default {
  layout: {
    default: ['1 2 3', '4 5 6', '7 8 9', `+ 0 ${SPECIAL_KEYS.BACKSPACE}`],
  },
};